export default __webpack_public_path__ + "static/media/check-list.283ddead.svg";